export default __webpack_public_path__ + "static/joint-pain-sucks-rugby-576add6a39f1928399addaa7616567cf.jpg";